import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar: React.FC = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => {
    setIsMenuOpen(false);
  };
  
  return (
    <nav className="w-full py-2 fixed top-0 z-50">
      <div className="flex items-center justify-between px-4 py-1.5 bg-dark backdrop-blur-md border-b border-black/10">
        {/* Logo */}
        <div className="flex items-center">
          <Link to="/" className="flex items-center" onClick={closeMenu}>
            <img src="/ValetPeLogo.avif" alt="ValetPe Logo" className="h-7" />
          </Link>
        </div>
        
        {/* Hamburger Menu Button */}
        <div className="relative">
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="p-2 rounded-full hover:bg-white/5 transition"
            aria-label="Toggle menu"
          >
            <svg
              className="w-6 h-6 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {isMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>

          {/* Dropdown Menu */}
          {isMenuOpen && (
            <div className="absolute right-0 mt-2 w-56 bg-dark rounded-lg shadow-lg border border-gray-800 overflow-hidden">
              <div className="py-2">
                <Link 
                  to="/" 
                  className={`block px-4 py-2 text-sm text-white hover:bg-white/5 transition ${
                    location.pathname === '/' ? 'bg-white/10' : ''
                  }`}
                  onClick={closeMenu}
                >
                  For Customers
                </Link>
                
                <Link 
                  to="/merchant" 
                  className={`block px-4 py-2 text-sm text-white hover:bg-white/5 transition ${
                    location.pathname === '/merchant' ? 'bg-white/10' : ''
                  }`}
                  onClick={closeMenu}
                >
                  For Merchants
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;